<template>
  <div>
    <div>
      <div class="topBox">
        <div class="sideList">
          <img src="../assets/left.png" @click="linkBack()" />
        </div>
        <div class="mainList">修改密码</div>
        <div class="sideList"></div>
      </div>
      <div class="topH"></div>
    </div>
    <div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="old_password"
          name="old_password"
          label="旧密码"
          placeholder="请输入旧密码"
          type="password"
          :rules="[{ required: true, message: '' }]"
        />
        <van-field
          v-model="new_password"
          name="new_password"
          label="新密码"
          placeholder="请输入新密码"
          type="password"
          :rules="[{ required: true, message: '' }]"
        />
       
        <van-field
          v-model="new_password_re"
          name="new_password_re"
          label="确认新密码"
          placeholder="请输入新密码"
          type="password"
          :rules="[{ required: true, message: '' }]"
        />
       
       
       
      
      
        <div class="subBtn" @click="subForm()">提交</div>
      </van-form>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {
  CellGroup,
  Cell,
  Button,
  Form,
  Field,
  Toast,
  Dialog,
} from "vant";


export default {
  data() {
    return {
      new_password: "",
      old_password:"",
      new_password_re:""
    };
  },

  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field,
    [Dialog.name]: Dialog,
  },
  methods: {
    linkBack() {
      this.$router.go(-1);
    },
   
    subForm() {
      var _this = this;
      if (this.old_password == "") {
        Toast("请填写旧密码");
        return;
      }
      if (this.new_password == "") {
        Toast("请填写新密码");
        return;
      }
      if (this.new_password !== this.new_password_re) {
        Toast("两次密码输入不一致");
        return;
      }
     
      var dd = {
        new_password: this.new_password,
        old_password: this.old_password,
             ticket:sessionStorage.getItem("ticket")
      };
      this.$post("/api/PhoneAPI/Modify_Password", dd)
        .then((res) => {
          if (res.IsSucceed) {
            Dialog.alert({
              message: res.Message,
            }).then(() => {
              _this.linkBack();
            });
          } else {
            Toast(res.Message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  
};
</script>
<style scoped>
.topBox {
  width: 375px;
  height: 44px;
  background-color: #444444;
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  align-content: center;
  justify-content: space-between;
}
.topH {
  height: 44px;
}
.sideList {
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sideList img {
  width: 18px;
  height: 18px;
  margin-right: 30px;
}
.mainList {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: white;
}
.subBtn {
  width: 200px;
  margin: 0 auto;
  background: #e62129;
  color: white;
  font-size: 16px;
  border-radius: 5px;
  line-height: 36px;
  height: 36px;
  margin-top: 40px;
}
</style>
